module.exports = __webpack_public_path__ + "static/baked_cupcakes-f2200bc02b0b9970248711646d7ef4bc.jpg";